import ContactModal from '~/components/ContactModal'; // Import the modal

export default function WorkTogether() {
  return (
    <section className="text-center pb-16 bg-gradient-to-r from-purple-900 to-blue-900 text-white">
      <h2 className="text-3xl sm:text-4xl font-extrabold">Collaborate With <span className="text-orange-400">Me</span></h2>
      <p className="mt-4 text-sm sm:text-lg max-w-3xl mx-auto">
        I help build <span className="text-red-400 font-extrabold">ambitious</span> yet <span className="text-blue-400 font-extrabold">user-friendly</span> products. Let's turn ideas into reality—together.
      </p>
      {/* Replace Link with ContactModal */}
      <div className="mt-6">
        <ContactModal />
      </div>
    </section>
  );
}
